import { LineConfig, TransformedDataPoint } from './prepareChartData';

// Transform incoming close-reason keyed data into chart-ready `data` and `lines`.
// Accept an optional `translate` function so localization can be applied outside of this helper.
export const prepareCloseReasonChartData = (
  rawByDate: Record<string, Record<string, { count: number; colorCode: string }>>,
): { data: TransformedDataPoint[]; lines: LineConfig[] } => {
  // collect unique reasons and assign stable ids
  const reasonMap = new Map<string, { id: number; color: string }>();
  let id = 1;
  const dates = Object.keys(rawByDate).sort();
  for (const date of dates) {
    const reasons = rawByDate[date] || {};
    for (const reasonName of Object.keys(reasons)) {
      if (!reasonMap.has(reasonName)) {
        reasonMap.set(reasonName, { id: id++, color: reasons[reasonName].colorCode });
      }
    }
  }

  const lines: LineConfig[] = Array.from(reasonMap.entries()).map(([reason, info]) => ({
    key: `action_${info.id}`,
    // allow caller to provide translated label, fallback to raw reason
    name: reason,
    color: info.color,
  }));

  const data: TransformedDataPoint[] = dates.map((date) => {
    const point: TransformedDataPoint = { name: date.split('-').reverse().join('.') };
    // initialize all known actions with 0
    for (const [, info] of Array.from(reasonMap.entries())) {
      point[`action_${info.id}`] = 0;
    }
    const reasonsForDate = rawByDate[date] || {};
    for (const [reasonName, payload] of Object.entries(reasonsForDate)) {
      const info = reasonMap.get(reasonName)!;
      point[`action_${info.id}`] = payload.count;
    }
    return point;
  });

  return { data, lines };
};
